import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioConfigEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioConfigEntity
